<template>
  <Field :label="label" :isRequired="isRequired">
    <div class="select is-fullwidth">
      <select @input="$emit('input', $event)" :value="value">
        <option value="" disabled>Unknown</option>
        <option v-for="(option, idx) in options" :key="idx" :value="option">
          {{ option }}
        </option>
      </select>
    </div>
  </Field>
</template>

<script>
import Field from './Field';

export default {
  name: 'InputField',
  components: {
    Field
  },
  props: {
    label: String,
    options: {
      type: Array,
      default: () => []
    },
    value: String,
    isRequired: {
      type: Boolean,
      default: false
    }
  }
};
</script>
